const values = {
  PKCS10: "PKCS10",
  SERVERGEN: "SERVER_GEN"
};
export default Object.freeze(values);
